import { useQuery } from "@tanstack/react-query"

import api2 from "~/api2"
import { queryKeys } from "~/constants/queryKeys"

export const useCamper = (camperId?: string) => {
  const fetchCamper = useQuery({
    queryKey: [queryKeys.CAMPER, camperId],
    queryFn: () => apiFetchCamper(camperId),
    enabled: !!camperId,
  })

  return {
    index: fetchCamper,
  }
}

const apiFetchCamper = async (camperId: string) => {
  try {
    return await api2.Camps.findCamper(camperId)
  } catch (error) {
    console.error("Error fetching Camper:", error)
    throw error
  }
}
